import React, { useState } from "react";

const Accordian = ({ title, desc, bgColor, srNo }) => {
	const [isActive, setIsActive] = useState(false);

	const handleAccordionClick = (e) => {
		setIsActive(e.target.checked && !isActive);
	};

	return (
		<div
			className={`collapse collapse-plus cursor-pointer rounded-none ${
				isActive
					? "bg-troo-primary collapse-open"
					: `${
							bgColor || "bg-troo-secondary"
					  } text-troo-stateTertiary collapse-close`
			}`}
		>
			<input type="radio" name="accordian" onClick={handleAccordionClick} />
			<h6 className="collapse-title px-7">{`${srNo}. ${title}`}</h6>
			<div className="collapse-content px-7">
				<p>{desc}</p>
			</div>
		</div>
	);
};

export default Accordian;
